/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_Ai_DescInputs */

const en_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Mistral — no setup needed`)
};

const de_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Mistral angetrieben -- keine Einrichtung erforderlich`)
};

const fr_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alimenté par Mistral -- aucune configuration nécessaire`)
};

const es_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impulsado por Mistral -- no se requiere configuración`)
};

const it_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenziato da Mistral — nessuna configurazione necessaria`)
};

const nl_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangedreven door Mistral — geen instelling nodig`)
};

const pl_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napędzane przez Mistral — nie wymaga konfiguracji`)
};

const fi_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistralin toimittama — ei asetuksia tarvita`)
};

const da_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drevet af Mistral — ingen opsætning nødvendig`)
};

const sv_onboarding_complete_ai_desc = /** @type {(inputs: Onboarding_Complete_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driven av Mistral — ingen inställning behövs`)
};

/**
* | output |
* | --- |
* | "Powered by Mistral — no setup needed" |
*
* @param {Onboarding_Complete_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_ai_desc = /** @type {((inputs?: Onboarding_Complete_Ai_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_Ai_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_ai_desc(inputs)
	if (locale === "fr") return fr_onboarding_complete_ai_desc(inputs)
	if (locale === "es") return es_onboarding_complete_ai_desc(inputs)
	if (locale === "it") return it_onboarding_complete_ai_desc(inputs)
	if (locale === "nl") return nl_onboarding_complete_ai_desc(inputs)
	if (locale === "pl") return pl_onboarding_complete_ai_desc(inputs)
	if (locale === "fi") return fi_onboarding_complete_ai_desc(inputs)
	if (locale === "da") return da_onboarding_complete_ai_desc(inputs)
	if (locale === "sv") return sv_onboarding_complete_ai_desc(inputs)
	return en_onboarding_complete_ai_desc(inputs)
});